export default __webpack_public_path__ + "static/media/rubic.c90ea58a.png";